import React from "react";
import { Redirect, Route } from "react-router-dom";

const PrivateRouteHandler = ({ component: Component, auth, ...rest }) => {
  const token = localStorage.getItem('id_token');

  if (!token) {
    return <Redirect to="/Login" />;
  }

  return (
    <Route {...rest} render={props => <Component {...props} />} />
  );
};

export default PrivateRouteHandler;
